'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["Icon", "active", "hovered", "use", "_useNativeButton"];
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { HoverProvider } from 'foundations-components/transitional/components/HoverProvider';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const getBackgroundColor = ({
  'aria-pressed': ariaPressed,
  active,
  theme
}) => {
  return ariaPressed || active ? theme.color['do-not-use-battleship'] : '';
};
const getBorderColor = ({
  'aria-pressed': ariaPressed,
  hovered,
  active,
  disabled,
  theme
}) => {
  if (!disabled) {
    if (ariaPressed || active) return theme.color['do-not-use-flint'];
    if (hovered) return theme.color['do-not-use-battleship'];
  }
  return 'transparent';
};
const StyledClickable = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Clickable, Object.assign({}, rest));
})(props => {
  const {
    theme
  } = props;
  return {
    background: getBackgroundColor(props),
    border: `${theme.borderWidth[100]} solid ${getBorderColor(props)}`,
    borderRadius: theme.borderRadius[100],
    display: 'inline-block',
    height: '27px',
    paddingBlock: theme.space[0],
    paddingInline: theme.space[100],
    verticalAlign: 'middle',
    transition: '150ms all ease-out',
    '&&': {
      cursor: props.disabled ? 'not-allowed' : 'initial'
    }
  };
});
const SimpleStyledClickable = props => {
  const {
    tokenProps,
    restProps
  } = filterTokenProps(props);
  return /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, restProps, {
    children: hoverProviderProps => {
      return /*#__PURE__*/_jsx(StyledClickable, Object.assign({}, tokenProps, restProps, hoverProviderProps));
    }
  }));
};
SimpleStyledClickable.displayName = 'SimpleStyledClickable';
export default SimpleStyledClickable;